import Line from './Line';
import Circle from './Circle';
export { Line, Circle };
export default {
  Line: Line,
  Circle: Circle
};


//////////////////
// WEBPACK FOOTER
// ../~/_rc-progress@2.5.2@rc-progress/es/index.js
// module id = 1361
// module chunks = 0